import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import EditDelegate from "./EditDelegate";

class DelegateRvdInfo extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showEditForm: false,
            rowKey: null,
            isDataSaved: true
        }
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            let key = {};
            await this.props.dispatch(this.props.WorkHolReqProxy_POBx_List_Now.execute(key));
            await this.props.dispatch(this.props.WorkHolReqProxy_POBx_List_One.execute(key, {withParams: true}));
            await this.props.dispatch(this.props.WorkHolReqProxy_POBx_List_All.execute(key));
        } catch (e) {
            await this.props.dispatch(e);
        }
    }

    onRefresh = async () => {
        try {
            await this.props.dispatch(this.props.WorkHolReqProxy_POBx_List_Now.refresh());
            await this.props.dispatch(this.props.WorkHolReqProxy_POBx_List_All.refresh());
        } catch (e) {
            await this.props.dispatch(e);
        }
    }

    createDelegation = async (event) => {
        event.preventDefault();
        this.setState({rowKey: null, showEditForm: true});
    }

    hideDelegation = async () => {
        this.setState({showEditForm: false});
        await this.onRefresh();
    }

    saveDelegation = async (event) => {
        event.preventDefault();
        await this.props.dispatch(this.props.WorkHolReqProxy_POBx_List_Now.save());
        if (this.props.WorkHolReqProxy_POBx_List_Now.isError) {
            return;
        }
        await this.props.dispatch(this.props.WorkHolReqProxy_POBx_List_All.refresh());
        this.setState({isDataSaved: true});
    }

    renderParams = (h) => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {h.fs.map(fld => {
                        return (<React.Fragment key={fld.fieldInfo.Name}>
                            <div className="row">
                                <div className="col-md-3 text-md-right field-title">
                                    {h.lbl(fld.Name)}
                                </div>
                                <div className="col-md-9">
                                    {h.ed(fld.Name)}
                                </div>
                            </div>
                            <hr/>
                        </React.Fragment>)
                    })}
                    {!this.state.isDataSaved &&
                        <button type="button"
                                className="btn btn-regular -goahead ml1ex mb-2"
                                onClick={this.saveDelegation}
                                disabled={false}>{i18next.t("Save")}</button>
                    }
                </div>
            </div>)
    }

    render() {
        const isDelegating = this.props.WorkHolReqProxy_POBx_List_Now.rowsCount() > 0;
        return (
            <>
                <PlaceholderWrapper placeholderId="10"
                                    title={<><i className='fa fa-file-text-o'/> {i18next.t("Delegate_RVD_Info_1")}</>}
                                    showSplitterLine={false} canCollapse={true}>
                    <ComplexParam dataItem={this.props.WorkHolReqProxy_POBx_List_Now} showSearchBar={false}
                                  showApplyButton={false} autoApplyParams={false} onEndEditField={() => {
                        this.setState({isDataSaved: false});
                    }}
                                  renderParams={this.renderParams}
                    />
                    <PlaceholderWrapper placeholderId="20"
                                        title={<><i className='fa fa-file-text-o'/> {i18next.t("RVD_Request_2")}</>}
                                        collapsed={true}
                                        showSplitterLine={false} canCollapse={true}>
                        <GridView dataItem={this.props.WorkHolReqProxy_POBx_List_All} allowPagination={true}
                                  readOnly={true}/>
                    </PlaceholderWrapper>
                    {
                        !isDelegating &&
                        <div className="text-left" style={{marginBottom: '10px'}}>
                            <button type="button"
                                    className="btn btn-regular -goahead ml1ex"
                                    onClick={this.createDelegation}
                                    disabled={false}>{i18next.t("Delegate")}</button>
                        </div>
                    }
                    {
                        this.state.showEditForm &&
                        <EditDelegate rowKey={this.state.rowKey}
                                      addMode={this.state.rowKey === null}
                                      onClose={this.hideDelegation}
                                      onRefresh={this.onRefresh}/>
                    }
                </PlaceholderWrapper>
            </>
        )
    }
}

DelegateRvdInfo.propTypes = {
    dispatch: PropTypes.func.isRequired,
    WorkHolReqProxy_POBx_List_Now: PropTypes.object,
    WorkHolReqProxy_POBx_List_All: PropTypes.object,
    WorkHolReqProxy_POBx_List_One_Params: PropTypes.object,
    WorkHolReqProxy_POBx_List_One: PropTypes.object
}

DelegateRvdInfo.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        WorkHolReqProxy_POBx_List_Now: state.rvdState.WorkHolReqProxy_POBx_List_Now,
        WorkHolReqProxy_POBx_List_All: state.rvdState.WorkHolReqProxy_POBx_List_All,
        WorkHolReqProxy_POBx_List_One_Params: state.rvdState.WorkHolReqProxy_POBx_List_One_Params,
        WorkHolReqProxy_POBx_List_One: state.rvdState.WorkHolReqProxy_POBx_List_One
    }
}

export default connect(mapStateToProps)(DelegateRvdInfo);